<template>
  <span class="lt-brand" v-html="svgMarkup"></span>
</template>

<script>
import { BRAND_SVGS } from './icons.js';

export default {
  name: 'LtBrand',
  props: {
    id: { type: String, required: true },
    size: { type: [Number, String], default: 22 },
  },
  computed: {
    svgMarkup() {
      let inner = BRAND_SVGS[this.id] || '<circle cx="12" cy="12" r="9" fill="currentColor" opacity=".15"/>';
      if (this.id === 'instagram') {
        inner = inner.replace(/ig-grad/g, `ig-grad-${this.id}`);
      }
      return `<svg width="${this.size}" height="${this.size}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">${inner}</svg>`;
    },
  },
};
</script>
